import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';

import Style from './ForgotPasswordCTA.module.scss';

const ForgotPasswordCTA = ({ containerClass, linkClass, linkText, onClick, text }) => {
  const containerStyle = containerClass || Style.signInForgotPasswordContainer;
  const linkStyle = linkClass || classNames(Style.signInForgotPassword, Style.link);
  const handleClick = () => {
    handleAnalytics({
      event: Events.PROFILE_SIGN_IN_FORGOT_PASSWORD,
    });
    onClick();
  };

  return (
    <div className={containerStyle}>
      {text}
      <button className={linkStyle} onClick={handleClick}>
        {linkText}
      </button>
    </div>
  );
};

ForgotPasswordCTA.defaultProps = {
  containerClass: null,
  linkClass: null,
  linkText: null,
  text: null,
};

ForgotPasswordCTA.propTypes = {
  containerClass: PropTypes.string,
  linkClass: PropTypes.string,
  linkText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string,
};

export default ForgotPasswordCTA;
